import React, { Suspense } from 'react';

// Lazy load the OptimizedBankLogo component
const OptimizedBankLogo = React.lazy(() => import('./OptimizedBankLogo'));

interface LazyOptimizedBankLogoProps {
  bankName: string;
  alt: string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  enableBunnyOptimization?: boolean;
}

// Loading skeleton component for OptimizedBankLogo
const BankLogoSkeleton: React.FC<{
  className?: string;
  size?: 'small' | 'medium' | 'large';
}> = ({ className = '', size = 'small' }) => {
  // Size mappings for skeleton
  const sizeMap = {
    small: 'w-5 h-5',
    medium: 'w-8 h-8',
    large: 'w-12 h-12',
  };

  return (
    <div className={`bg-gray-200 animate-pulse rounded ${sizeMap[size]} ${className}`}>
      <div className="flex items-center justify-center h-full">
        <svg className="w-3 h-3 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
};

const LazyOptimizedBankLogo: React.FC<LazyOptimizedBankLogoProps> = (props) => {
  return (
    <Suspense fallback={<BankLogoSkeleton className={props.className} size={props.size} />}>
      <OptimizedBankLogo {...props} />
    </Suspense>
  );
};

export default LazyOptimizedBankLogo;
export { BankLogoSkeleton };
